import { render, staticRenderFns } from "./SubgroupInput.vue?vue&type=template&id=4002b55a"
import script from "./SubgroupInput.vue?vue&type=script&lang=js"
export * from "./SubgroupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports